module.exports = __webpack_public_path__ + "static/media/battery-quarter.a95465a9.svg";